import React from "react";
import CustomCardComponent from "./custom-card.component";
import { ICustomCard } from "./types";

const CustomCardContainer = (props: ICustomCard) => {
  return <CustomCardComponent {...props} />;
};

export default CustomCardContainer;
